<template>
  <div class="content">
    <Header :title="'帮助中心'" />
    <div class="problem-wrap">
      <div v-if="categoryList.length" class="category-wrap">
        <nut-tab :is-scroll="true" @tab-switch="tabSwitch">
          <nut-tab-panel v-for="(item,index) of categoryList" :key="index" :tab-title="item.name" />
        </nut-tab>
      </div>
      <div class="list-wrap">
        <div class="detail">
          <ul v-if="detailList.length">
            <li
              v-for="(item,index) in detailList"
              :key="index"
              @click="goDetail(item.id)"
            >{{ item.title }}</li>
          </ul>
          <div v-if="!detailList.length" class="no-data">抱歉！暂无数据</div>
        </div>
        <!-- 分页 -->
        <div class="page-container">
          <van-pagination
            v-model="pageIndex"
            :total-items="total"
            :show-page-size="3"
            :items-per-page="pageSize"
            force-ellipses
            @change="pageChange"
          />
        </div>
      </div>
    </div>
    <Footer :active="4" />
  </div>
</template>
<script>
import Vue from 'vue'
import { Pagination } from 'vant'
import { Toast } from '@nutui/nutui'
import Header from '@/components/Header/Index'
import Footer from '@/components/Footer/Index'
import { helpCategory, helpList } from '@/api/Help/index'

Vue.use(Pagination)

export default {
  name: 'Help',
  components: { Header, Footer },
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      categoryId: 0,
      categoryList: [],
      detailList: []
    }
  },
  mounted() {
    this.initcategoryList()
    this.initDetailList()
  },
  methods: {
    initcategoryList() {
      helpCategory().then(res => {
        if (res && res.success) {
          if (res.data) {
            this.categoryList.push({ id: 0, name: '全部' })
            res.data.forEach(item => {
              this.categoryList.push(item)
            })
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    initDetailList() {
      const helpCategoryId = 0
      const params = {
        categoryId: helpCategoryId,
        pageIndex: 1,
        pageSize: this.pageSize
      }
      helpList(params).then(res => {
        if (res && res.success) {
          if (res.data) {
            this.total = res.data.total
            const rows = res.data.rows
            if (rows) {
              this.detailList = rows
            }
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    tabSwitch(index, event) {
      this.categoryId = this.categoryList[index].id
      if (this.pageIndex !== 0) {
        this.pageIndex = 0
      }
      this.getDetailList()
    },
    pageChange() {
      this.getDetailList()
    },
    getDetailList() {
      const params = {
        categoryId: this.categoryId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      helpList(params).then(res => {
        if (res && res.success) {
          if (res.data) {
            this.total = res.data.total
            const rows = res.data.rows
            if (rows) {
              this.detailList = rows
            }
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    goDetail(id) {
      this.$router.push({
        name: 'HelpDetail',
        params: {
          id: id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/index.scss';

.content {
  display: flex;
  flex-direction: column;
  padding-bottom: 50px;
  background: url('~@/assets/images/helpList-bg.png') no-repeat bottom;
  background-size: 100% auto;

  .problem-wrap {
    width: 100%;
    min-height: calc(100vh - 50px);
    // overflow: hidden;
    box-sizing: border-box;
    .category-wrap {
      width: 100%;
      box-sizing: border-box;
      padding: 10px 15px;
      min-height: 0;
      height: auto;
    }

    .list-wrap {
      min-height: 0;
      height: auto;
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      padding: 0 15px;

      .detail {
        min-height: 0;
        height: auto;
        width: 100%;
        box-sizing: border-box;
        border-radius: 5px;
        overflow: hidden;
        background: #ffffff;
        margin-bottom: 25px;

        ul {
          li {
            margin: 0 15px;
            position: relative;
            height: 42px;
            line-height: 42px;
            box-sizing: border-box;
            font-size: 13px;
            font-weight: bold;
            color: #333333;
            @extend %ellipsis;
            &::after {
              @extend %border-bottom;
            }
          }

          li:last-child::after {
            display: none;
          }
        }

        .no-data {
          width: 100%;
          height: 40px;
          line-height: 40px;
          text-align: center;
          font-size: 13px;
          color: #999999;
        }
      }
    }
  }
}

::v-deep .nut-tab {
  background: transparent;
  border: none;

  .nut-tab-title {
    border: none;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    font-weight: bold;

    .nav-bar {
      display: none;
    }

    .nut-title-nav-scroll {
      background: #e5e5e5;
      height: 30px;
      line-height: 30px;
      flex-shrink: 0;
      text-align: center;
      width: auto;
      font-size: 13px;
      color: #000;
      margin-right: 12px;
      border-radius: 3px;
    }

    .nut-tab-active {
      background: -moz-linear-gradient(left, #f2a511 0%, #f7c926 100%);
      background: -webkit-gradient(linear, left right, left right, color-stop(0%, #f2a511), color-stop(100%, #f7c926));
      background: -webkit-linear-gradient(left, #f2a511 0%, #f7c926 100%);
      background: -o-linear-gradient(left, #f2a511 0%, #f7c926 100%);
      background: -ms-linear-gradient(left, #f2a511 0%, #f7c926 100%);
      background: linear-gradient(to right, #f2a511 0%, #f7c926 100%);
      filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f2a511', endColorstr='#f7c926', GradientType=0);

      a {
        color: #fff;
        font-size: 13px;
      }
    }
  }

  .nut-tab-item {
    display: none;
  }
}

::v-deep .nut-tab-link {
  font-size: 13px;
  color: #999;
}

.van-pagination {
  margin-bottom: 30px;
  justify-content: center;

  ::v-deep .van-pagination__item {
    color: #555;
    border-radius: 5px;
    margin: 0 3px;
    font-weight: bold;
    height: 35px;
  }

  ::v-deep .van-pagination__item::after {
    display: none;
  }

  ::v-deep .van-pagination__item:disabled {
    background: #fff;
    opacity: 1;
    color: #ddd;
  }

  ::v-deep .van-pagination__item:active {
    background-color: $primary-color-bright;
    color: #fff;
  }

  ::v-deep .van-pagination__item--disabled {
    background: #fff;
    opacity: 1;
    color: #ddd;
  }

  ::v-deep .van-pagination__item--active {
    background-color: #fff;
    color: $primary-color;
  }

  ::v-deep .van-pagination__prev {
    max-width: 150px;
  }

  ::v-deep .van-pagination__next {
    max-width: 150px;
  }
}
</style>
